<template>
  <!-- Czy most do Subiekta żyje. Bez tego „W kolejce" od pół godziny wygląda tak samo
       jak „W kolejce" od pięciu sekund - a to dwie zupełnie różne sytuacje. -->
  <span v-tooltip="tooltip"
    :class="[state.chip, 'inline-flex select-none items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium']">
    <span class="relative flex h-2 w-2">
      <span v-if="state.pulse" :class="[state.dot, 'absolute inline-flex h-full w-full animate-ping rounded-full opacity-60']"></span>
      <span :class="[state.dot, 'relative inline-flex h-2 w-2 rounded-full']"></span>
    </span>
    {{ state.text }}
  </span>
</template>

<script>
import moment from 'moment';

export default {
  name: 'SubiektBridgeStatus',
  props: {
    status: { type: Object, default: null },
    queued: { type: Number, default: 0 },
  },
  computed: {
    state() {
      if (this.status == null || this.status.ostatniKontaktUnix == null) {
        return { text: 'Most: brak danych', chip: 'bg-gray-100 text-gray-600', dot: 'bg-gray-400' };
      }
      if (this.status.online) {
        return {
          text: this.queued > 0 ? `Most pracuje · ${this.queued} w kolejce` : 'Most połączony',
          chip: 'bg-green-50 text-green-700',
          dot: 'bg-green-500',
          pulse: this.queued > 0,
        };
      }
      return { text: 'Most offline', chip: 'bg-red-50 text-red-700', dot: 'bg-red-500' };
    },
    tooltip() {
      if (this.status == null || this.status.ostatniKontaktUnix == null) {
        return 'Most do Subiekta jeszcze się nie zgłosił (wersja 2.0 lub nowsza).';
      }
      const contact = moment.unix(this.status.ostatniKontaktUnix);
      const parts = [`Ostatni kontakt: ${contact.format('DD.MM.YYYY HH:mm:ss')}`];
      if (this.status.host) parts.push(`serwer: ${this.status.host}`);
      if (this.status.wersja) parts.push(`wersja: ${this.status.wersja}`);
      return parts.join(' · ');
    },
  },
};
</script>
